//
import { ProductModel } from '@/models'

/**
 *
 */
const remove = async function ( id ) {

    //
    try {

        //
        let product  = await ProductModel.find( id ),
            response = await product.delete()

        //
        return response.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default remove